import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Facebook, Camera } from "lucide-react";
import { subscribeNewsletter } from "../../api/newsletter.api";
import logo from "../../images/footerlogo.jpg";
import { Link, useNavigate } from "react-router-dom";
import { fetchBrands } from "../../api/brands.api";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [brands, setBrands] = useState([])
  const navigate = useNavigate();;


  useEffect(() => {
    const loadBrands = async () => {
      try {
        const data = await fetchBrands();
        setBrands(data);
      } catch (err) {
        console.error("Failed to load brands");
      }
    };

    loadBrands();
  }, []);


  const handleSubscribe = async () => {
    if (isLoading) return;

    setMessage("");

    if (!email.trim()) {
      setMessage("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      const res = await subscribeNewsletter(email);
      setMessage(res?.message || "Subscribed successfully");
      setEmail("");
    } catch (err) {
      setMessage(err.message || "Subscription failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="footer-wrapper">
      <div className="footer-main">
        <div className="footer-main2">
          <div className="footer-col logo-col">
            <img src={logo} alt="Diecast Zone" className="footer-logo" />
          </div>

          <div className="footer-col">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/combos">Combo set</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="/membership">Join Our Membership</Link>
              </li>
              <li>
                <Link to="/vendor-partner">Vendor Partner</Link>
              </li>
              <li>
                <Link to="/shipping-and-delivery">Shipping & Delivery</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
            </ul>
          </div>


          <div className="footer-col">
            <h4>Shop By Brand</h4>
            <ul className={`brand-list ${brands.length > 7 ? "two-col" : ""}`}>
              {brands.map((brand) => (
                <li
                  key={brand.id}
                  onClick={() => navigate(`/category/${brand.name}`)}
                  className="brand-link"
                >
                  {brand.name}
                </li>
              ))}
            </ul>

          </div>


          <div className="footer-col">
            <h4>Subscribe</h4>
            <p className="subscribe-text">
              Sign up for updates, new arrivals, and exclusive offers.
            </p>

            <div className="subscribe-box">
              <input
                type="email"
                placeholder="Enter email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
              <button onClick={handleSubscribe} disabled={isLoading}>
                {isLoading ? "SUBSCRIBING..." : "SUBSCRIBE"}
              </button>
            </div>

            {message && (
              <p className="subscribe-message">{message}</p>
            )}

            <h4 className="follow-title">Follow Us</h4>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/groups/899427564720418"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Facebook"
                title="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/164diecastzone?igsh=bXhnYzFpZWpqMDZt&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                title="Instagram"
              >
                <Camera size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © 2025 Diecastzone.in Limited. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
